/**
 * @generated SignedSource<<c15c07129f767daabfdfe84e1097aff9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchUserMessageFragment$data = {
  readonly id: string;
  readonly messageText: string;
  readonly " $fragmentType": "BrainSearchUserMessageFragment";
};
export type BrainSearchUserMessageFragment$key = {
  readonly " $data"?: BrainSearchUserMessageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchUserMessageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchUserMessageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageText",
      "storageKey": null
    }
  ],
  "type": "BrainSearchMessage",
  "abstractKey": null
};

(node as any).hash = "a039adf02c3eadec405b6dc03b79c192";

export default node;
